import { render, staticRenderFns } from "./agentDetails.vue?vue&type=template&id=38e49ae2&scoped=true"
import script from "./agentDetails.vue?vue&type=script&lang=js"
export * from "./agentDetails.vue?vue&type=script&lang=js"
import style0 from "./agentDetails.vue?vue&type=style&index=0&id=38e49ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e49ae2",
  null
  
)

export default component.exports